import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TruncateString from "react-truncate-string";
import { formatBytes } from "../../libs/utils";

class FileBlock extends Component {
  static propTypes = {
    file: PropTypes.object,
    isToEncrypt: PropTypes.bool,
    isToHide: PropTypes.bool,
    isAccountable: PropTypes.bool,
    onRemove: PropTypes.func,
    isFoldersEdit: PropTypes.bool
  };

  render() {
    const { file, isToHide, isToEncrypt, onRemove } = this.props;
    let progressClass = "";
    let description = formatBytes(file.size, 2);
    if (!file.acceptedFile || file.isErrorUploaded) {
      progressClass = "invalid";
      description = file.errorMessage
        ? file.errorMessage
        : "File in formato non valido";
    }
    if (file.progress || file.isUploading) {
      progressClass = "startProgress";
      description = file.isUploading ? (
        <div>
          {formatBytes((file.size * file.progress) / 100, 2)} di{" "}
          {formatBytes(file.size, 2)}
          <div className="percentageText">{file.progress}%</div>
        </div>
      ) : (
        formatBytes(file.size, 2)
      );
    }
    return (
      <div className="fileBlock" style={{width: this.props.isFoldersEdit && "100%"}}>
        <div className="leftSide">
          <div style={{ display: "flex" }}>
            <div style={{ flex: "0 0 auto" }}>
              {isToEncrypt && (
                <FontAwesomeIcon
                  icon={["fal", "key"]}
                  style={{ color: "#0090d1", marginRight: "8px" }}
                />
              )}
              {isToHide && (
                <FontAwesomeIcon
                  icon={["fal", "minus-octagon"]}
                  style={{ color: "#d82829", marginRight: "8px" }}
                />
              )}
            </div>
            <div
              className="fileNameTruncate"
              style={{ flex: "1 0 auto", width: "100%", fontSize: this.props.isFoldersEdit && 13}}
            >
              <TruncateString
                text={file.name}
                style={{ display: "inline-block" }}
              />
            </div>
          </div>

          {!this.props.isFoldersEdit &&
            <div className="descriptiveDiv">{description}</div>
          }
          <div className={"progressBar " + progressClass}>
            <div
              className={"progressColored"}
              style={{
                width: file.progress ? file.progress + "%" : 0,
                backgroundImage: "linear-gradient(274deg, #00c3ea, #0090d1)",
                height: "100%"
              }}
            />
          </div>
        </div>
        <div className="rightSide">
          <div
            className={file.isUploading ? "invisibleIcon" : "activeRedIcon"}
            onClick={e => {
              e.preventDefault();
              !file.isUploading && onRemove(file);
            }}
          >
            <FontAwesomeIcon icon={["fal", "trash-alt"]} />
          </div>
          {!this.props.isFoldersEdit &&
            <div
              className={file.isUploading ? "invisibleIcon" : "activeRedIcon"}
              style={{ color: "#c9d9e8" }}
            >
              <FontAwesomeIcon icon={["fal", "eye"]} />
            </div>
          }
        </div>
      </div>
    );
  }
}

export default FileBlock;
